import React from "react";
import "../static/css/ServiceHeader.css";

const ServiceHeader = ({ image, title, description, overlayDescription }) => {
  return (
    <>
      <div className="service-header-img">
        <div
          className={`serhead-container ${
            overlayDescription ? "serhead-overlay-mode" : ""
          }`}
        >
          <div className="serviceheader-content">
            <h4>{title}</h4>
            <hr className="serhead-line" />
            {!overlayDescription && description && <p>{description}</p>}
          </div>
          {overlayDescription && description && (
            <div className="overlay-description">
              <p>{description}</p>
            </div>
          )}
          {/* <img src={image} alt="servicehead-image" /> */}
        </div>
      </div>
    </>
  );
};

export default ServiceHeader;
